"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PAY_AT_BRANCH: 'PAY_AT_BRANCH',
    CHECKOUT: 'CHECKOUT',
    APPLE_PAY: 'APPLE_PAY',
    ONLINE: 'ONLINE',
};
